import { styled, Box, Card } from '@ltvco/refresh-lib/theme';

export const SidebarCard = styled(Card)(({ theme }) => ({
  borderRadius: 10,
  padding: theme.spacing(2),
  boxShadow: theme.shadows[1],
}));

export const OrderSummaryCard = styled(Card)(({ theme }) => ({
  borderRadius: 10,
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.default,
}));

export const SidebarHeader = styled(Box)(({ theme }) => ({
  fontWeight: 800,
  textTransform: 'uppercase',
  background: theme.palette.background.default,
  border: `1px solid ${theme.palette.divider}`,
  borderBottom: 'none',
  borderTopLeftRadius: 10,
  borderTopRightRadius: 10,
  padding: theme.spacing(1.25, 2),
}));

export const SidebarBody = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderTop: 'none',
  borderBottomLeftRadius: 10,
  borderBottomRightRadius: 10,
  padding: theme.spacing(2),
}));
